import React from 'react';
import { GlobeAmericasIcon, MagnifyingGlassCircleIcon, MapIcon, PencilIcon } from '@heroicons/react/24/solid';
import SharedNavbarBottom from 'shared_items/NavbarBottom';

// Wrapper de compatibilidade — preserva a assinatura original (activeTab).
// Implementação real em shared_items/NavbarBottom.jsx (design-system fase 2/3). Remover em fase 4.
const TABS = [
  { key: 'overview', label: 'Overview', Icon: GlobeAmericasIcon },
  { key: 'trips', label: 'Trips', Icon: MapIcon },
  { key: 'explore', label: 'Explore', Icon: MagnifyingGlassCircleIcon },
  { key: 'notes', label: 'Notes', Icon: PencilIcon },
];

const NavbarBottom = ({ activeTab, handleTabChange }) => (
  <SharedNavbarBottom
    tabs={TABS}
    activeTab={activeTab}
    onTabChange={handleTabChange}
    moduleKey="travel"
  />
);

export default NavbarBottom;
